import { useEffect, useState } from "react"
import { Crown } from "lucide-react"
import StateConstants from "src/states/StateContstants"
import { isPaidAccountType } from "src/components/premium/Subscription"

export function planBadgeLabel(accountType: string | null | undefined): string {
    if (accountType === "lifetime") return "Lifetime"
    return isPaidAccountType(accountType) ? "Plus" : "Free"
}

export default function PlanBadge({ stateHandler }: { stateHandler: any }) {
    const [accountType, setAccountType] = useState<string | null>(stateHandler.get(StateConstants.ACCOUNT_TYPE) ?? null)

    useEffect(() => {
        let mounted = true
        stateHandler.addListener(StateConstants.ACCOUNT_TYPE, (value: string | null) => {
            if (mounted) setAccountType(value ?? null)
        })
        return () => { mounted = false }
    }, [stateHandler])

    const label = planBadgeLabel(accountType)
    const isPaid = isPaidAccountType(accountType)
    return (
        <span className="header-premium-badge" title={`${label} plan`} aria-label={`${label} plan`}>
            {isPaid && <Crown size={14} strokeWidth={2} />}
            <span>{label}</span>
        </span>
    )
}
